import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  const isFor = ['First-time moms with infants aged 0-6 months.', 'Moms who are physically and emotionally exhausted from "sleep battles."', 'Parents who want a gentle, science-based alternative to "Cry It Out."', 'Anyone who feels like their baby "hates" the crib.'];
  const notFor = ['Parents looking for a "magic pill" that guarantees 12 hours of sleep overnight.', 'Those who prefer rigid, clock-based sleep training schedules.', 'Families with toddlers (this is specifically for the newborn nervous system).'];
  return <section className="bg-cream py-20 px-6" data-id="element-111">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-112">
        {/* Who it's for */}
        <div className="bg-white rounded-2xl p-8 shadow-sm border-t-4 border-sage" data-id="element-113">
          <h3 className="text-2xl font-serif mb-6 text-charcoal" data-id="element-114">
            This is perfect for you if...
          </h3>
          <ul className="space-y-4" data-id="element-115">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-116">
                <Check className="w-5 h-5 text-sage shrink-0 mt-1" data-id="element-117" />
                <span className="font-sans text-charcoal/80" data-id="element-118">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Who it's not for */}
        <div className="bg-white rounded-2xl p-8 shadow-sm border-t-4 border-charcoal/20" data-id="element-119">
          <h3 className="text-2xl font-serif mb-6 text-charcoal" data-id="element-120">
            This is NOT for you if...
          </h3>
          <ul className="space-y-4" data-id="element-121">
            {notFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-122">
                <X className="w-5 h-5 text-charcoal/40 shrink-0 mt-1" data-id="element-123" />
                <span className="font-sans text-charcoal/60" data-id="element-124">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}